import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtService } from 'app/generic/JwtService';
import { NewModalService } from 'app/generic/new-modal/new-modal.service';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MappaAllertaService extends JwtService {

  constructor(private http: HttpClient,
    public router: Router,
    public modalComponent: NewModalService) {
    super(router, modalComponent);
  }

  selectAllOggi(): Promise<any> {
    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/bollettinometeo/findLastBollettino', super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));

  }

  selectAllDomani(): Promise<any> {
    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/bollettinometeo/findBollettinoDomani', super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

  findByIdZona(zona: any, numeroAvviso: any): Promise<any> {
    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/bollettinometeo/findByIdZona/' + zona + '/' + numeroAvviso, super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }
}
